import { render } from "./PreguntaTable.vue?vue&type=template&id=c38cbf36&scoped=true"
import script from "./PreguntaTable.vue?vue&type=script&lang=js"
export * from "./PreguntaTable.vue?vue&type=script&lang=js"

import "./PreguntaTable.vue?vue&type=style&index=0&id=c38cbf36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c38cbf36"]])

export default __exports__